import { INSURANCE_TYPES } from '../../../constants';
import type { ContentData } from '../types';

const data: ContentData = {
  meta: {
    description:
      'Travelling to Bali and need travel insurance? With cover for lost luggage and medical expenses, plus add-ons like scooter insurance we’ve got you sorted.',
    title: 'Travel Insurance for Bali - ahm Travel insurance',
  },
  sections: [],
  type: INSURANCE_TYPES.TRAVEL,
};

export default data;
